import React, { useEffect, useRef, useState } from 'react';
import { useUserLinkCreate } from './apiHooks';
import { FormattedMessage } from 'react-intl';
import Loader from '../loader';
import ErrorMessage from '../errorMessage';
import utils from '../../utils/utils';

const UserLinkField = ({ formData, onChange, schema }) => {
  const [userLink, setUserLink] = useState(null);
  const [typedUrl, setTypedUrl] = useState(null);
  const [url, setUrl] = useState(null); // for triggering actual search
  const queryTimer = useRef(null);

  useEffect(() => {
    if (!userLink && formData) {
      setUserLink(formData);
      setTypedUrl(formData.url);
    }
  }, [formData]);

  useEffect(() => {
    clearTimeout(queryTimer.current);
    queryTimer.current = setTimeout(() => {
      setUrl(typedUrl);
    }, 500);
  }, [typedUrl]);

  const {
    createUserLink,
    isLoading: loading,
    isError,
    error,
  } = useUserLinkCreate((userLink) => {
    setUserLink(userLink);
    onChange(userLink);
  });

  useEffect(() => {
    if (url && (!userLink || url !== userLink.url)) {
      createUserLink({ userLink: { url } });
    } else if (!url) {
      setUserLink(null);
    }
  }, [url]);

  return (
    <div>
      <Loader show={loading} />
      {isError ? <ErrorMessage error={utils.getErrorMessageFromResponse(error)} /> : ''}

      <div className="form-group field field-string">
        <label className="control-label">
          <FormattedMessage id={schema.title} />
        </label>
        <input
          className="form-control"
          placeholder=""
          type="text"
          value={typedUrl}
          onChange={(e) => setTypedUrl(e.target.value)}
        />
      </div>

      {userLink ? (
        <div className="panel-block m-b-3">
          <h4>{userLink.title}</h4>
          <p>
            <a className="link" href={userLink.url}>
              {userLink.url}
            </a>
          </p>
          <p>{userLink.description}</p>
          {userLink.imageUrl ? (
            <div className="row">
              <div className="col-2">
                <img className="img-fluid panel-block__image" src={userLink.imageUrl} alt="" />
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

UserLinkField.propTypes = {};

UserLinkField.defaultProps = {};

export default UserLinkField;
